import BackNextButtons from 'components/BackNextButtons';
import { getFullName } from 'components/forms/RealNameInfo';
import RevenueForm from 'components/forms/RevenueForm';
import values from 'stores/values';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

const Revenue: React.FC<ProgressFormProps> = ({ onSubmit }) => {
    const customerInfo = values.getParams();
    const name = getFullName(customerInfo);

    const handleSubmit = (ev: React.FormEvent) => {
        onSubmit('../agreements', ev);
    };

    return (
        <form noValidate className="open-revenue-root" onSubmit={handleSubmit}>
            <RevenueForm name={name} customerInfo={customerInfo} />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    id: 'revenue',
    cache: false,
    showProgressBar: false,
    ensure: 'baseinfo',
    basePath: 'open',
    eventParams: {
        exposureEventParams: {
            model: '开户-税务信息',
            name: '税务信息-页面曝光'
        },
        submitEventParams: {
            model: '开户-税务信息',
            name: '税务信息-点击下一步'
        }
    }
})(Revenue);
